import { render } from "./CountryProfileRisk.vue?vue&type=template&id=409fdc34"
import script from "./CountryProfileRisk.vue?vue&type=script&lang=js"
export * from "./CountryProfileRisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__